// extracted by mini-css-extract-plugin
export default {"color_banner":"ColorBanner_color_banner__d5dSy","link_button":"ColorBanner_link_button__kpbex"};